import React, { Component } from "react";

class LevelProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <div className="col-3 d-xl-block d-lg-none d-md-none d-sm-none d-none pb-1">
      <div
        id="circleProgress1"
        className="progressbar-js-circle ml-5"
        data-tip={`${this.props.levelsCompleted} out of ${this.props.levels} levels completed`}
      >
        <svg
          viewBox="0 0 100 100"
          style={{ display: "block", width: "50%" }}
        >
          <path
            d="M 50,50 m 0,-48 a 48,48 0 1 1 0,96 a 48,48 0 1 1 0,-96"
            stroke="#eee"
            strokeWidth="5"
            fillOpacity="0"
          ></path>
          <path
            d="M 50,50 m 0,-48 a 48,48 0 1 1 0,96 a 48,48 0 1 1 0,-96"
            stroke="#0AFF1D"
            strokeWidth="5"
            fillOpacity="0"
            style={{
              strokeDasharray: "301.635, 301.635",
              strokeDashoffset:
                `calc( 301.635 - (301.635 * ${this.props.levelProgress}) / 100 )`,
            }}
          ></path>
        </svg>
        <div
          className="progressbar-text"
          style={{
            position: "absolute",
            left: "54%",
            top: "44%",
            padding: "0px",
            margin: "0px",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "14px",
          }}
        >
          {" "}
          {this.props.levelProgress}%{" "}
        </div>
      </div>
    </div>
    );
  }
}
export default LevelProgress;
